import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from '../brand/BrandLogo';

const MARK = `${process.env.PUBLIC_URL || ''}/latentstack-mark.svg`;

/**
 * LatentStack brand mark on its own — the yellow chevron over the blue bar, for
 * icon-sized spots. Reads on light and dark grounds alike. Sized by height; width
 * follows the artwork ratio.
 */
export function LogoMark({ size = 28, className = '' }) {
  return (
    <img
      src={MARK}
      alt="LatentStack"
      width={Math.round(size * (76 / 148))}
      height={size}
      className={`inline-block select-none ${className}`}
      style={{ height: size, width: 'auto' }}
      draggable={false}
    />
  );
}

/** Full logo (mark + wordmark) as a link home. `size` matches the old mark height. */
function Logo({ to = '/', size = 26, className = '' }) {
  return (
    <Link to={to} className={`inline-flex items-center group ${className}`} aria-label="LatentStack home">
      <BrandLogo height={Math.round(size * 0.8)} className="transition-transform group-hover:-translate-y-0.5" />
    </Link>
  );
}

export default Logo;
